import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Collapse } from "reactstrap";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";
import CmtModal_IssueStageCompleted from "./CmtModal_IssueStageCompleted";
import cmtIssueStageActions from "../../../_actions/_qmsActions/cmtIssueStageActions";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import { QMS } from "../../../_constants/actionConstants";
import moment from "moment";
import { getLocalISOString } from "../../../_utils/generalUtils";
import CmtModal_EditIssueStageAttachments from "./CmtModal_EditIssueStageAttachments";

export default function CmtIssueDetail_Left(props) {
  const {
    issueStage,
    divisionId,
    showModal_editStage,
    getOwnerTeamLabel,
    deleteCallback,
  } = props;

  useEffect(
    () => dispatch(qmsTeamActions.getMembers(issueStage ? issueStage.ownerTeamId : 0)),
    [issueStage]
  );

  const dispatch = useDispatch();
  const fetching = useSelector((state) => state.qms.fetching);
  const issue = useSelector((state) =>
    issueStage ? state.qms.openIssues[issueStage.issueId] || null : null
  );

  const [expandedLeftSections, setExpandedLeftSections] = useState({
    info: false,
    stageOwners: false,
    files: false,
  });

  const [modalState_issueStageCompleted, setModalState_issueStageCompleted] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_issueStageCompleted = () =>
    setModalState_issueStageCompleted({
      ...modalState_issueStageCompleted,
      showModal: !modalState_issueStageCompleted.showModal,
    });

  const [modalState_editAttachments, setModalState_editAttachments] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_editAttachments = () =>
    setModalState_editAttachments({
      ...modalState_editAttachments,
      showModal: !modalState_editAttachments.showModal,
    });

  const handleClick_startStage = async (e) => {
    e.preventDefault();
    const startedOn = getLocalISOString(new Date());
    await dispatch(
      cmtIssueStageActions.start(issueStage.issueId, issueStage.issueStageId, startedOn)
    );
    dispatch(cmtIssueActions.get(issueStage.issueId));
    dispatch(cmtIssueActions.getAll(divisionId));
  };

  const handleClick_editStage = (e) => {
    e.preventDefault();
    showModal_editStage(issueStage);
  };

  const handleClick_deleteIssueStage = async (e) => {
    e.preventDefault();
    deleteCallback(null);
    await dispatch(
      cmtIssueStageActions.remove(issueStage.issueId, issueStage.issueStageId)
    );
    dispatch(cmtIssueActions.get(issueStage.issueId));
    dispatch(cmtIssueActions.getAll(divisionId));
  };

  return (
    <>
      <CmtIssueDetail_Left_Header
        expandedLeftSections={expandedLeftSections}
        setExpandedLeftSections={setExpandedLeftSections}
        section="info"
        title="Stage Info"
      >
        <CmtIssueDetail_Left_StageInfo
          issueStage={issueStage}
          getOwnerTeamLabel={getOwnerTeamLabel}
        />
      </CmtIssueDetail_Left_Header>
      <CmtIssueDetail_Left_Header
        expandedLeftSections={expandedLeftSections}
        setExpandedLeftSections={setExpandedLeftSections}
        section="stageOwners"
        title="Stage Owners"
      >
        <CmtIssueDetail_Left_StageOwners
          issueStage={issueStage}
          getOwnerTeamLabel={getOwnerTeamLabel}
        />
      </CmtIssueDetail_Left_Header>
      <CmtIssueDetail_Left_Header
        expandedLeftSections={expandedLeftSections}
        setExpandedLeftSections={setExpandedLeftSections}
        section="files"
        title={`Files${
          issueStage && issueStage.attachments && ` (${issueStage.attachments.length})`
        }`}
      >
        <CmtIssueDetail_Left_Files issueStage={issueStage} />
      </CmtIssueDetail_Left_Header>
      {issue && issue.isOpen && !issueStage.isSystemGenerated && (
        <div className="d-flex flex-row flex-wrap">
          <button
            id="editIssueStage"
            name="editIssueStage"
            onClick={handleClick_editStage}
            className="btn btn-secondary py-1 mr-2"
          >
            Edit...
          </button>
          {issueStage.isCurrent ? (
            <button
              id="markIssueStageComplete"
              name="markIssueStageComplete"
              onClick={toggleModal_issueStageCompleted}
              className="btn btn-success py-1 mr-2"
            >
              <FontAwesomeIcon icon="flag-checkered" className="fa-fw mr-1" />
              Mark Complete
            </button>
          ) : (
            <button
              id="startStage"
              name="startStage"
              onClick={handleClick_startStage}
              className="btn btn-info py-1 mr-2"
            >
              <FontAwesomeIcon icon="play" className="fa-fw mr-1" />
              {issueStage.isCompleted ? "Restart" : "Start"}
            </button>
          )}
          {!issueStage.isCompleted && (
            <button
              id="deleteIssueStage"
              name="deleteIssueStage"
              onClick={handleClick_deleteIssueStage}
              className="btn btn-danger py-1 mr-2"
            >
              <FontAwesomeIcon icon="trash-alt" className="fa-fw mr-1" />
              Delete
            </button>
          )}
        </div>
      )}
      {modalState_issueStageCompleted.showModal && (
        <CmtModal_IssueStageCompleted
          modalState={modalState_issueStageCompleted}
          toggleModal={toggleModal_issueStageCompleted}
          issueStage={issueStage}
          issueId={issueStage.issueId}
          divisionId={divisionId}
        />
      )}
      {modalState_editAttachments.showModal && (
        <CmtModal_EditIssueStageAttachments
          modalState={modalState_editAttachments}
          toggleModal={toggleModal_editAttachments}
          issueStageId={selectedStageId}
          divisionId={divisionId}
          tabId={tabId}
        />
      )}
    </>
  );
}

function CmtIssueDetail_Left_Header(props) {
  const { expandedLeftSections, setExpandedLeftSections, section, title } = props;

  return (
    <div className="card bg-lightgray mb-2">
      <div className="card-body p-1">
        <div
          className="issue-stage__lt-head"
          onClick={() =>
            setExpandedLeftSections({
              ...expandedLeftSections,
              [section]: !expandedLeftSections[section],
            })
          }
        >
          <div className="issue-stage__lt-head--collapse">
            <FontAwesomeIcon
              icon={expandedLeftSections[section] ? "caret-down" : "caret-right"}
              className="fa-fw"
            />
          </div>
          <div className="issue-stage__lt-head--title">{title}</div>
        </div>
        <div className="issue-stage__lt-body">
          <Collapse isOpen={expandedLeftSections[section]}>{props.children}</Collapse>
        </div>
      </div>
    </div>
  );
}

function CmtIssueDetail_Left_StageInfo(props) {
  const { issueStage, getOwnerTeamLabel } = props;

  const fetching = useSelector((state) => state.qms.fetching);
  const qmsUsers = useSelector((state) =>
    issueStage ? state.qms.qmsUsersForIssue[issueStage.issueId] || null : null
  );

  const getStartedBy = useCallback(() => {
    if (!issueStage || !issueStage.startedByQmsUserId) return "(N/A)";

    const qmsUser = (qmsUsers || []).find(
      (qu) => qu.qmsUserId === issueStage.startedByQmsUserId
    );

    if (!qmsUser) return "(N/A)";

    return qmsUser.fullName || "(N/A)";
  }, [issueStage, qmsUsers]);

  return (
    <div className="card m-1">
      <div className="card-body p-2">
        <ul className="list-group-flush border-0 pl-0 mb-2">
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-5 pr-1 font-weight-bold">Started:</div>
              <div className="col-7 pl-1">
                {issueStage
                  ? new Date(issueStage.startedOn).toLocaleDateString()
                  : fetching
                  ? "Loading..."
                  : "(N/A)"}
              </div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-5 pr-1 font-weight-bold">Started By:</div>
              <div className="col-7 pl-1">{fetching ? "Loading..." : getStartedBy()}</div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-5 pr-1 font-weight-bold">Owner:</div>
              <div className="col-7 pl-1">
                {issueStage
                  ? getOwnerTeamLabel(issueStage.issueStageId)
                  : fetching
                  ? "Loading..."
                  : "(N/A)"}
              </div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-5 pr-1 font-weight-bold">Completed:</div>
              <div className="col-7 pl-1">
                {issueStage
                  ? issueStage.isCompleted
                    ? new Date(issueStage.completedOn).toLocaleDateString()
                    : "Ongoing"
                  : fetching
                  ? "Loading..."
                  : "(N/A)"}
              </div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-5 pr-1 font-weight-bold">Duration:</div>
              <div className="col-7 pl-1">
                {issueStage
                  ? `${(issueStage.duration || 0) + " Days"}${
                      !issueStage.isCompleted ? " (Ongoing)" : ""
                    }`
                  : fetching
                  ? "Loading..."
                  : "(N/A)"}
              </div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-5 pr-1 font-weight-bold">Description:</div>
              <div className="col-7 pl-1">
                {issueStage
                  ? issueStage.description || "(N/A)"
                  : fetching
                  ? "Loading..."
                  : "(N/A)"}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

function CmtIssueDetail_Left_StageOwners(props) {
  const { issueStage, getOwnerTeamLabel } = props;

  const qmsTeamMembers = useSelector((state) =>
    issueStage ? state.qms.qmsTeamMembers[issueStage.ownerTeamId] || null : null
  );
  const fetching = useSelector((state) => state.qms.fetching);

  return (
    <div className="card m-1">
      <div className="card-body p-2">
        {issueStage ? (
          <>
            Users for
            {` ${getOwnerTeamLabel(issueStage.issueStageId)}:`}
            {(qmsTeamMembers || []).map((qtm, index) => (
              <div key={`stageOwnerKey_${index}`} className="list-group-flush mb-0">
                <div className="list-group-item py-0">
                  {`${qtm.fullName} (${qtm.distUnit})`}
                </div>
              </div>
            ))}
          </>
        ) : fetching ? (
          "Loading..."
        ) : (
          "(N/A)"
        )}
      </div>
    </div>
  );
}

function CmtIssueDetail_Left_Files(props) {
  const { issueStage } = props;

  const dispatch = useDispatch();

  const fetching = useSelector((state) => state.qms.fetching);

  const qmsUsers = useSelector((state) =>
    issueStage ? state.qms.qmsUsersForIssue[issueStage.issueId] || null : null
  );

  const getQmsUserName = useCallback(
    (qmsUserId) => {
      if (!qmsUsers || !qmsUserId) return "(N/A)";
      const qmsUser = (qmsUsers || []).find((u) => u.qmsUserId === qmsUserId);
      return qmsUser ? qmsUser.fullName : "(N/A)";
    },
    [qmsUsers]
  );

  const handleClick_downloadFile = (isaId, filename) => (e) => {
    e.preventDefault();

    dispatch(cmtIssueStageActions.downloadFile(isaId, filename));
  };

  return (
    <div className="card m-1">
      <div className="card-body p-2">
        {issueStage ? (
          issueStage.attachments && issueStage.attachments.length > 0 ? (
            <div className="px-0 mb-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <div
                className="d-flex flex-row py-1"
                style={{ position: "sticky", top: "0" }}
              >
                <div className="px-1 font-weight-bold" style={{ width: "45%" }}>
                  Filename
                </div>
                <div className="px-1 font-weight-bold" style={{ width: "30%" }}>
                  Uploaded On
                </div>
                <div className="px-1 font-weight-bold" style={{ width: "25%" }}>
                  By
                </div>
              </div>
              {(issueStage.attachments || []).map((f) => (
                <div
                  key={`issueDetailLeftFiles_${f.issueStageAttachmentId}`}
                  className="d-flex flex-row py-1 px-0 w-100 border-top"
                >
                  <div className="px-1" style={{ width: "45%" }}>
                    <button
                      id={`issueDetailLeftFiles_${f.issueStageAttachmentId}`}
                      name={`issueDetailLeftFiles_${f.issueStageAttachmentId}`}
                      className="btn btn-link px-1 py-0 text-left text-small"
                      style={{ textOverflow: "ellipsis", maxWidth: "100%" }}
                      onClick={handleClick_downloadFile(
                        f.issueStageAttachmentId,
                        f.originalFilename
                      )}
                    >
                      {f.originalFilename}
                    </button>
                  </div>
                  <div className="px-1 text-small" style={{ width: "30%" }}>
                    {f.createdOn ? `${new Date(f.createdOn).toLocaleString()}` : "(N/A)"}
                  </div>
                  <div
                    className="px-1 text-small"
                    style={{ width: "25%", textOverflow: "ellipsis" }}
                  >
                    {getQmsUserName(f.uploadedByQmsUserId)}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            "No files for this stage"
          )
        ) : fetching ? (
          "Loading..."
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
